import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetHistoryReplenishment = (id) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params: id,
                method: 'get',
                url: urls.GET_LIST_REPLENISHMENT
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetReplenishmentAction(data.data));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetHistoryReplenishment as SetGetHistoryReplenishment
}